module.exports = __webpack_public_path__ + "static/media/marketing_header.7c980452.jpeg";